export default {
  setNotificationTabs(state, tabs) {
    state.notificationTabs = tabs;
  },
  setNotifications(state, notifications) {
    state.notifications = notifications;
  },
  setMyOrders(state, myOrders) {
    state.myOrders = myOrders;
  },
  setTestOrders(state, testOrders) {
    state.testOrders = testOrders;
  },
  setRolesNotification(state, notifications) {
    state.rolesNotification = notifications
  }
};
